// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"54d23b91","126":"55b3aef6","171":"a3df2495","946":"f284b25d"}[chunkId] + ".chunk.js";
};